import { cloneDeep } from "lodash";
import { action, observable } from "mobx";
import { deviceOptions, discoveryOptions, languageOptions } from "../constants";
import { ApplicationValues, JobCategoryEnum } from "../types/models";

const EMPTY_APPLICATION: ApplicationValues = {
    resume: undefined,
    photo: undefined,
    portfolio: undefined,
    video: undefined,
    motivationalLetter: undefined,
    optionalFiles: [],
    optionalLinks: [],
    device: deviceOptions[0].value,
    discovery: discoveryOptions[0].value,
    email: "",
    experience: 0,
    gdprAccepted: false,
    jobCategory: null,
    motivation: "",
    firstName: "",
    lastName: "",
    noticePeriod: "",
    phone: "",
    previousProjects: undefined,
    salary: "",
    startDate: null,
    tags: undefined,
    workHours: "",
    language: languageOptions[0].value
};

type ApplicationStep = "personalData" | "details" | "motivation" | "dataUpload" | "verification";

class ApplicationStore {
    @observable isStepFinished: { [key in ApplicationStep]: boolean } = {
        personalData: false,
        details: false,
        motivation: false,
        dataUpload: false,
        verification: false
    };

    @observable currentApplication: ApplicationValues;

    // This variable is used to toggle whether or not the user can navigate using the "back" button or the SideBar
    @observable canNavigate = true;

    // This variable is used to store a function to validate the currently active form.
    // It is called by SideBar when a user tries to navigate away from a form that isn't correctly filled.
    @observable validateForm?: () => void;

    constructor() {
        this.currentApplication = cloneDeep(EMPTY_APPLICATION);
    }

    @action setJobCategory = (jobCategory: JobCategoryEnum) => {
        this.currentApplication.jobCategory = jobCategory;
    };

    @action reset = () => {
        this.currentApplication = cloneDeep(EMPTY_APPLICATION);
        Object.keys(this.isStepFinished).forEach((step) => (this.isStepFinished[step as ApplicationStep] = false));
    };

    @action setCurrentAndNextStepsToUnfinished = (activeStep: number) => {
        const isStepFinished = Object.keys(this.isStepFinished) as ApplicationStep[];

        for (let step = activeStep; step < isStepFinished.length; step++) {
            applicationStore.isStepFinished[isStepFinished[step]] = false;
        }
    };
}

const applicationStore = new ApplicationStore();

export { applicationStore };
